import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { tokenStorage } from '../../utils/localStorage';

export interface User {
  id: string;
  email: string;
  name: string;
  role: 'admin' | 'customer' | 'member';
  customerId: string | null;
}

interface AuthState {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

const initialState: AuthState = {
  token: tokenStorage.getToken(),
  user: tokenStorage.getUser(),
  isAuthenticated: tokenStorage.hasToken(),
  isLoading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true;
    },
    loginSuccess: (state, action: PayloadAction<{ token: string; user: User }>) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.isLoading = false;
      tokenStorage.setToken(action.payload.token);
      tokenStorage.setUser(action.payload.user);
    },
    loginFailure: (state) => {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      tokenStorage.removeToken();
      tokenStorage.removeUser();
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      tokenStorage.removeToken();
      tokenStorage.removeUser();
    },
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      tokenStorage.setUser(action.payload);
    },
    updateUserAndToken: (state, action: PayloadAction<{ token: string; user: User }>) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.isAuthenticated = true;
      tokenStorage.setToken(action.payload.token);
      tokenStorage.setUser(action.payload.user);
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, setUser, updateUserAndToken } = authSlice.actions;
export default authSlice.reducer;